// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxTitle_wrapper__31EBO","nowrap":"BoxTitle_nowrap__3iiYr","tag":"BoxTitle_tag__36dQE"};